/**
 * @file im
 */

import { useWsStore } from '@/store/ws';
import { useUserStore } from '@/store/User';

import { pinia } from './index';

const wsStore = useWsStore(pinia);
const userStore =  useUserStore(pinia);

export const useImStore = defineStore('imStore', {
  state: () => ({
    imList: [],
    showIm: false,
    chatApply: {},
    chatApplyResult: {},
    applyList: <any>[],
    messageList: <any>[],
    localMessage: <any>[],
    sendLoading: false,
    activeId: '',
    isMore: false,
    isCancel: '',
    isShowLeaderUserId: '',
    isSend: '',
    isImClose: false
  }),

  getters: {
    imWsClose() {
      return wsStore.imWsClose;
    }
  },
  actions: {
    createWS() {
      wsStore.createWS('im');
    },
    setImWsClose() {
      wsStore.imWsClose = false;
    },
    start() {
      wsStore.imWS && wsStore.imWS.start();
    },
    cancelWS(type:string) {
      wsStore.unSub(type, wsStore.imWS);
    },
    subIm(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        (res: any) => {
          if (res.success && res.data) {
            this.imList = res.data || [];
          }
        }, null, true
      );
    },
    subImApply(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        (res: any) => {
          this.chatApply = res || {};
        }, null, true
      );
    },
    subImApplyResult(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        (res: any) => {
          if (res.success) {
            this.chatApplyResult = res.data || {};
            this.isCancel =  Math.random().toString(36).slice(2);
            // if (!res.data.agree) {
            //   this.isCancel =  Math.random().toString(36).slice(2);
            // }
          }
        }, null, true
      );

    },
    async subImMessageList(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      return new Promise((resolve, reject) => {
        wsStore.imWS?.sub(
          {
            id: par.type,
            ...par
          },
          () => null,
          (res: any) => {
            if (res.success) {
              if (res.data) {
                if (res.data.length == 0) {
                  this.isMore = true;
                }
                if (res.data) {
                  this.messageList.unshift(...res.data.reverse());
                  resolve(res);
                }

              }
            }
            reject(false);
          }, null, true
        );
      });

    },
    subImCancel(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        (res: any) => {
          if (res.success) {
            this.isCancel =  Math.random().toString(36).slice(2);
          }
        }, null, true
      );
    },
    async subImPersonMessage(par:any) {
      this.sendLoading = true;
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      return new Promise((resolve, reject) => {
        wsStore.imWS?.sub(
          {
            id: par.type,
            ...par
          },
          () => null,
          (res: any) => {
            this.sendLoading = false;
            if (res.success) {
              if (res.data?.senderId) {
                // 发送的id==当前选中的用户 聊天记录才会追加
                if (this.activeId === res.data.senderId) {
                  this.localMessage.push(res.data);
                  this.isSend =  Math.random().toString(36).slice(2);
                } else {
                  this.subIm({
                    'type': 'chat-list',
                    'requestId': userStore.userinfo?.userId
                  });
                }
              } else {
                this.subIm({
                  'type': 'chat-list',
                  'requestId': userStore.userinfo?.userId
                });
              }

              resolve(res);
            } else {
              reject(false);
            }
          }, null, true
        );
      });
    },
    subImDelete(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        () => {
          //
        }, null, true
      );
    },
    subImTop(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        () => {
          //
        }, null, true
      );
    },
    subImClearUnread(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        () => {
          //
        }, null, true
      );
    },
    subImApplyList(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        (res: any) => {
          if (res.success) {
            if (res.data) {
              this.applyList = res.data || [];
            }
          }
        }, null, true
      );
    },
    subImError(par:any) {
      if (!wsStore.imWS) {
        wsStore.createWS('im');
      }
      wsStore.imWS?.sub(
        {
          id: par.type,
          ...par
        },
        () => null,
        (res: any) => {
          if (res.code === 1013) {
            this.showIm = false;
            this.isImClose = true;
            this.cancelWS('im');
          }
        }, null, true
      );
    }
  }
});
